export default __webpack_public_path__ + "static/media/profileColor.9b70c7f4.png";